/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open rebuy cart and exit
    try {
        window.Rebuy.SmartCart.show();
    } catch (e) {
        document.addEventListener('rebuy:smartcart.ready', (event) => {
            window.Rebuy.SmartCart.show();
        });
    }
    return;

    document.querySelector("#miniCart").classList.add("open");

    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    let cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());
    let variantIDToSellingPlanName = cartData.variantIDToSellingPlanName;
    let variantIDToSellingPlanID = cartData.variantIDToSellingPlanID;
    let variantIDToCompareAtPrice = cartData.variantIDToCompareAtPrice;

    // remove protection or free containers
    // get all protection items
    for (const item of cart.items) {
        if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
            cart = await updateCart({updates: {[cartSettings.protection_upsell.variants[0].id]: 0}});
            await openCart(true);
        }
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#headerIconsCart span").textContent = cart.item_count;

    //  update cart count in cart header
    document.querySelector("#miniCartHeaderTitle span").textContent = cart.item_count !== 0 ? `(${cart.item_count})` : "";

    // update price
    if (document.querySelector('#miniCartUpsellSwitchInput')?.checked) {
        document.querySelector("#miniCartFooterTotal span").textContent = price(cart.items_subtotal_price + +document.querySelector('#miniCartUpsellPrice')?.dataset?.price);
    } else {
        document.querySelector("#miniCartFooterTotal span").textContent = price(cart.items_subtotal_price);
    }

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartUpsell")?.classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell")?.classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // if 3 0r more items in the cart, add border to upsell
    if (cart.items.length >= 3) {
        document.querySelector("#miniCartUpsell")?.classList.add("border");
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {

        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
                comparePrice = variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }

            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<s>${price(comparePrice, false)}</s>`;
            }

            /****************** actual price ******************/

            HTML += price(item.final_line_price, false);

            /***************** savings *****************/

            // check for savings
            if (comparePrice) {
                let savings = comparePrice - item.final_line_price;
                if (savings > 0) {
                    HTML += `<span>(Save ${price(savings, false)})</span>`;
                }
            }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {

            // check if already a subscription
            if (item.selling_plan_allocation || !cartSettings.include_subscriptions_add_on) {
                return "";
            }

            // get selling plan id and name
            let sellingPlanID = variantIDToSellingPlanID[item.variant_id];
            let sellingPlanName = variantIDToSellingPlanName[item.variant_id];

            // check if selling plan exists
            if (!sellingPlanID) {
                return "";
            }

            // return HTML
            return `
            <div class="miniCartBodyItemUpgradeWrap">
                <div class="miniCartBodyItemUpgradeText">${cartSettings.upgrade_text}</div>
                <button
                    class="miniCartBodyItemUpgrade button"
                    data-key="${item.key}"
                    data-quantity="${item.quantity}"
                    data-plan="${sellingPlanID}">
                    ${sellingPlanName}
                </button>
            </div>
            `;
        }

        // check for alternate image
        let imageSource = item.image;
        if (cartSettings.alt_images_image[item.product_id]?.image) {
            imageSource = cartSettings.alt_images_image[item.product_id]?.image;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
            <div class="miniCartBodyItemInner">
                <img class="miniCartBodyItemImage" src="${imageSource}&width=200" alt="${item.product_title}">
                <div class="miniCartBodyItemFlex">
                    <div class="miniCartBodyItemFlexInner">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </div>
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">+</button>
                        </div>
                    </div>
                    <div class="miniCartBodyItemFlexInner">
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                        <button class="miniCartBodyItemRemove">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59L13.59 5L15 6.41L11.41 10L15 13.59Z" fill="#000901"/>
                            </svg>
                        </button>
                    </div>
                </div>
                </div>
                ${upgradeHTML()}
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        if (cartSettings.include_subscriptions_add_on) {
            element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
                const key = this.dataset.key;
                const quantity = parseInt(this.dataset.quantity);
                const sellingPlanID = parseInt(this.dataset.plan);

                // start loading animation
                document.querySelector("#miniCartContent").classList.add("loading");

                // add selling plan
                cart = await changeCart({
                    id: key,
                    quantity: quantity,
                    selling_plan: sellingPlanID
                });

                await openCart(true);

                // remove loading animation
                this.classList.remove("loading");
            });
        }
    });
}

// listen for Upsell switch
document.querySelector("#miniCartUpsellSwitchInput")?.addEventListener("change", function () {
    this.parentElement.classList.toggle("active", !this.parentElement.classList.contains("active"));
    setTimeout(() => {
        openCart(true);
    }, 400);
});

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function () {
        openCart();
    });
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").classList.remove("open");
    setTimeout(() => {
        document.querySelector("#miniCart").close();
    }, 400)
}

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
});

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // check if upsell product - if so atc
    if (document.querySelector("#miniCartUpsellSwitchInput")?.checked) {
        // formdata
        let formData = {
            items: []
        };
        // add product
        formData.items.push({
            quantity: 1,
            id: cartSettings.protection_upsell.variants[0].id,
        });
        // add to cart
        if (formData.items.length > 0) {
            await addProduct(formData);
        }
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));


// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}